module.exports = "pegasus_template/assets/graycircle-tumblr.png";